/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import NodeCollection from '../Utility/Component/ComponentReference/NodeCollection';
import NodeCollectionEffectBase from './NodeCollectionEffectBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class SheetSwapEffect extends NodeCollectionEffectBase
{
    @property({ type: cc.SpriteAtlas, visible: true })
    protected to: cc.SpriteAtlas = null;

    @property({ type: cc.SpriteAtlas, visible: true })
    protected from: cc.SpriteAtlas = null;

    @property({ visible: true })
    protected prefetch: boolean = false;

    @property({ visible: true })
    protected fetchOnce: boolean = false;

    @property({ visible: true })
    protected reverse: boolean = false;

    @property({ type: [cc.Node], visible: true })
    protected targets: cc.Node[] = [];

    private _targets: cc.Sprite[] = null;

    private _referencedNodesFetched: boolean = false;

    protected trigger = (): void =>
    {
        this.swap();
        this.complete();
    }

    protected onInitStateChange(): boolean
    {
        if (!super.onInitStateChange() || !this.prefetch) { return false; }

        this.fetchTargets();
        return true;
    }

    protected swap(): void
    {
        this.fetchTargets();

        const to: cc.SpriteAtlas = this.reverse ? this.from : this.to;

        for (let target of this._targets)
        {
            if (!target.spriteFrame) { continue; }

            const newFrame: cc.SpriteFrame = to.getSpriteFrame(target.spriteFrame.name);
            if (newFrame)
            {
                target.spriteFrame = newFrame;
            }
        }
    }

    private fetchTargets(): void
    {
        if (this._targets && this.fetchOnce) { return; }
        this.fetchReferenceNodes();

        let targets: cc.Sprite[] = [];
        for (let target of this.targets)
        {
            let top: cc.Sprite = target.getComponent(cc.Sprite);
            let children: cc.Sprite[] = target.getComponentsInChildren(cc.Sprite);

            if (top) { targets.push(top); }
            if (children) { targets = targets.concat(children); }
        }

        this._targets = targets;
    }

    private fetchReferenceNodes(): void
    {
        if (this._referencedNodesFetched || !this.reference.HasValue()) { return; }
        this._referencedNodesFetched = true;

        const nodeCollection: NodeCollection = this.reference.Value.getComponent(NodeCollection);
        if (!nodeCollection) { return; }

        this.targets.push(...nodeCollection.Nodes);
    }
}
